export default __webpack_public_path__ + "static/media/IMG_3077_4_11zon.3e29779f.jpg";